import { Component } from '@angular/core';
import { TrayService } from './tray.service';

@Component({
  selector: 'app-modal-tray',
  templateUrl: './tray.component.html',
  styles: [`
    :host {
      display: block;
      bottom: 0;
      right: 0;
      position: fixed;
      z-index: 999;
    }
    .bs-minimized-modals-container{
      display: flex;
    }
    .bs-minimized-modal{
      background: #eee;
      margin: 0 10px;
      padding: 5px 15px;
      border-radius: 3px 3px 0 0;
      cursor: pointer;
    }
  `]
})
export class TrayComponent {
  modals: any[];
  constructor(private trayService: TrayService) {
    this.modals = this.trayService.modals;
    this.trayService.updateTray.subscribe((modals: any) => {
      this.modals = modals;
      localStorage.setItem('bs-draggable-modals-tray', JSON.stringify(this.modals));
    });
  }

  openModal(modal: any) {
    this.trayService.maximizeModal.emit(modal);
  }

}
